import PageLayout from '@/views/containers/layouts/PageLayout';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import DevelopmentRoute from '../DevelopmentRoute';
import { useSelector } from 'react-redux';
import { ReduxState } from '@/redux/modules/types';
import { testsRoutesRegistry } from './tests-routes-registry';
import { Button } from '@capintel/component-lib/button';

type TestRoute = {
  pathSegment: string;
  name: string;
  inPageLayout?: boolean;
  render: () => JSX.Element;
};

export type TestRouteSection = {
  key: string;
  pathSegment: string;
  name: string;
  tests: TestRoute[];
};

const TestsRouter: React.FC = () => {
  const [hideHeader, setHideHeader] = React.useState(true);
  const tests = testsRoutesRegistry();
  const history = useHistory();
  const currentPath = history.location.pathname;
  const auth = useSelector((state: ReduxState) => state.auth);
  useEffect(() => {
    if (currentPath === '/tests') {
      setHideHeader(false);
    }
  }, [currentPath]);

  const getPath = (section: TestRouteSection, route: TestRoute) => `/tests/${section.pathSegment}${route.pathSegment}`;

  return (
    <div className="dev-tests-page">
      {!hideHeader && (
        <div className="tests-header">
          {tests.length === 0 && <p>No tests to display at the moment.</p>}
          <div className="tests-links">
            {tests.map(section => (
              <div key={section.key} className="tests-section">
                <p>{section.name}</p>
                <ul>
                  {section.tests.map(route => (
                    <li key={getPath(section, route)} className={currentPath === getPath(section, route) ? 'active' : ''}>
                      <a href={getPath(section, route)}>{route.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      )}
      <Button
        onClick={() => setHideHeader(!hideHeader)}
        variant="primary"
        size="small"
        appearance="icon"
        aria-label="Toggle tests options"
        icon={hideHeader ? 'chevron-down' : 'chevron-up'}
      />
      <div className="tests-content">
        {tests.map(section =>
          section.tests.map(route =>
            route.inPageLayout ? (
              <DevelopmentRoute
                user={auth.user ?? null}
                key={getPath(section, route)}
                path={getPath(section, route)}
                component={() => <PageLayout>{route.render()}</PageLayout>}
              />
            ) : (
              <DevelopmentRoute user={auth.user ?? null} key={getPath(section, route)} path={getPath(section, route)} component={route.render} />
            ),
          ),
        )}
      </div>
    </div>
  );
};

export default TestsRouter;
